<script setup>
import { onMounted } from "vue";
/* global Weglot, defineProps */

defineProps({
  title: { type: String, required: true },
  version: { type: String, default: "" },
  effective: { type: String, default: "" },
});

onMounted(async () => {
  window.scrollTo(0, 0);
  // Tell Weglot about the freshly rendered DOM (same pattern as App.vue)
  if (window.Weglot && Weglot.initialized) {
    try {
      await Weglot.addNodes();
    } catch (e) {
      console.warn("[LegalPage] Weglot.addNodes failed", e);
    }
  }
});
</script>

<script>
export default { inheritAttrs: false };
</script>

<template>
  <div class="body-container legal-wrapper">
    <article class="legal">
      <header class="legal-head">
        <h1 class="legal-title">{{ title }}</h1>
        <p v-if="effective" class="legal-meta">Effective Date: {{ effective }}</p>
        <p v-if="version" class="legal-meta">{{ version }}</p>
      </header>

      <slot />

      <footer class="legal-foot">
        <p>
          TalentSage LLC &amp; TalentSage UK Limited &copy; 2007 - 2026 | All
          Rights Reserved | Privacy Office: Privacy@TalentSage.com
        </p>
      </footer>
    </article>
  </div>
</template>

<style scoped>
.legal-wrapper {
  padding: 30px 20px 50px;
}

.legal {
  max-width: 820px;
  margin: 0 auto;
  line-height: 1.6;
  font-size: 15px;
}

.legal-head {
  text-align: center;
  margin-bottom: 30px;
}

.legal-title {
  font-size: 30px;
  margin: 0 0 8px;
  color: #0e5071;
}

.legal-meta {
  margin: 2px 0;
  font-size: 13px;
  color: #777;
  font-style: italic;
}

.legal :deep(h2) {
  font-size: 22px;
  margin: 38px 0 12px;
  color: #0e5071;
}

.legal :deep(h3) {
  font-size: 17px;
  margin: 24px 0 8px;
  color: #2f7ba8;
}

.legal :deep(p),
.legal :deep(li) {
  margin: 0 0 10px;
}

.legal :deep(ul),
.legal :deep(ol) {
  margin: 0 0 12px;
}

.legal :deep(.plain) {
  background: #f0f3f7;
  border-left: 4px solid #0e5071;
  padding: 12px 16px;
  margin: 0 0 18px;
  border-radius: 0 4px 4px 0;
}

.legal :deep(.plain-label) {
  display: block;
  font-weight: 700;
  font-size: 13px;
  margin-bottom: 4px;
  color: #0e5071;
}

.legal :deep(.plain p) {
  margin: 0;
  font-style: italic;
}

.legal :deep(.sub) {
  margin-left: 24px;
}

.legal-foot {
  margin-top: 50px;
  padding-top: 14px;
  border-top: 1px solid #ddd;
  text-align: center;
  font-size: 12px;
  color: #777;
}

@media (max-width: 900px) {
  .legal-wrapper {
    padding: 20px 14px 40px;
  }
  .legal-title {
    font-size: 24px;
  }
  .legal :deep(.sub) {
    margin-left: 12px;
  }
}
</style>
